// Success stories, problem data, vision — extends mockData.js
export const problemStats = [
  {
    value: 700,
    suffix: "M+",
    label: "people facing economic insecurity",
    desc: "living paycheck to paycheck across low and middle-income nations.",
    source: "World Bank, 2025",
  },
  {
    value: 733,
    suffix: "M",
    label: "experiencing food insecurity",
    desc: "one in eleven people worldwide can't count on their next meal.",
    source: "UN FAO, 2024",
  },
  {
    value: 1400,
    suffix: "M+",
    label: "lack access to opportunity",
    desc: "no mentors, no networks, no on-ramps to fair work or education.",
    source: "ILO, 2025",
  },
];

export const bigImpact = [
  { key: "families", label: "Families helped", end: 128420, suffix: "+" },
  { key: "meals", label: "Meals shared", end: 384210, suffix: "+" },
  { key: "jobs", label: "Jobs created", end: 3241, suffix: "" },
  { key: "volunteers", label: "Volunteers connected", end: 12384, suffix: "+" },
  { key: "communities", label: "Communities served", end: 620, suffix: "" },
];

export const successStories = [
  {
    id: "s1",
    name: "Amina R.",
    role: "Home health aide · Brooklyn, NY",
    image: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=600&q=80",
    quote:
      "When my mother needed dialysis rides, three neighbors showed up within an hour. NeighborNet didn't just match us — it built a real, lasting friendship on my block.",
    outcome: "12 rides delivered · 3 lifelong friends",
  },
  {
    id: "s2",
    name: "Kwame O.",
    role: "Bakery founder · Accra, Ghana",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=600&q=80",
    quote:
      "I had a recipe and a dream. NeighborNet matched me with a mentor and 6 volunteers. Eighteen months later, we serve 400 families a week.",
    outcome: "$0 → sustainable small business",
  },
  {
    id: "s3",
    name: "Sofia R.",
    role: "First-gen student · Mexico City",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=600&q=80",
    quote:
      "The AI matched me with someone who had walked my exact path. She read every essay draft. I'm now the first in my family in college.",
    outcome: "Accepted to 4 universities · full ride",
  },
];

export const futureVisionMilestones = [
  { year: "2026", title: "620 communities · 47 countries", desc: "Proving product-market fit in dense urban neighborhoods." },
  { year: "2027", title: "10,000 communities · 90 countries", desc: "AI matching engine scales to hyper-local city blocks." },
  { year: "2028", title: "1M+ families helped monthly", desc: "Government + NGO partnerships in emerging markets." },
  { year: "2030", title: "The default social infrastructure", desc: "A world where nobody in your net goes without help." },
];
